export default __webpack_public_path__ + "f65a9535d9b408c3c1f3ea611b6a8a88.png";